import { Locale, SiteName, getLocale } from '@libs/core';
import { CLIENT_ID, SANDBOX, SFCC_VERSION } from './environment';

const siteName: SiteName = SiteName[getLocale()];

export const OCAPI_BASE_URL = `${SANDBOX}/s/${siteName}/dw`;
export const OCAPI_SHOP_PATH = `/shop/${SFCC_VERSION}`;
export const OCAPI_DATA_PATH = `/data/${SFCC_VERSION}`;

const OCAPI_SHOP_URL = OCAPI_BASE_URL + OCAPI_SHOP_PATH;

const sfccCloudflareOrigin =
    getLocale() === Locale['en-CA']
        ? process.env.VELOCITY_SFCC_CA_ORIGIN
        : process.env.VELOCITY_SFCC_US_ORIGIN;

export const OCAPI_API_URLS = {
    CLIENT_AUTH_URL: `${OCAPI_SHOP_URL}/customers/auth?client_id=${CLIENT_ID}`,
    CLIENT_SYNC_COOKIES_URL: `${sfccCloudflareOrigin}/on/demandware.store/Sites-${siteName}-Site/default/Ping-Show`,
    CLIENT_SESSIONS_URL: `${OCAPI_SHOP_URL}/sessions?client_id=${CLIENT_ID}`,
    BASKETS_URL: `${OCAPI_SHOP_URL}/baskets`,

    BASKET_ITEMS_URL: (basketId: string) =>
        `${OCAPI_SHOP_URL}/baskets/${basketId}/items`,

    CUSTOMER_URL: (customerId: string) =>
        `${OCAPI_SHOP_PATH}/customers/${customerId}`,

    MULTI_PRODUCT_PROMOTIONS_URL: (productId: string) =>
        `${OCAPI_SHOP_PATH}/products/${productId}?expand=prices,variations,availability,promotions,options`,
    PRODUCT_PROMOS_URL: (productId: string) =>
        `${OCAPI_SHOP_PATH}/products/${productId}/promotions`,

    PRODUCT_URL: (productId: string) =>
        `${OCAPI_SHOP_PATH}/products/${productId}?expand=variations,availability,promotions`,

    WISH_LIST_ITEMS_URL: (customerId: string, listId: string) =>
        `${OCAPI_API_URLS.WISH_LIST_URL(customerId)}/${listId}/items`,

    WISH_LIST_URL: (customerId: string) =>
        `${OCAPI_SHOP_PATH}/customers/${customerId}/product_lists`,
    STORE_BY_ID: (storeId: string) =>
        `${OCAPI_SHOP_PATH}/stores/${storeId}?client_id=${CLIENT_ID}`,
    SAVE_STORE_GUEST_USER: `${SANDBOX}/on/demandware.store/Sites-${siteName}-Site/default/Stores-SaveStore`,
    SAVE_POSTAL_CODE: `${SANDBOX}/on/demandware.store/Sites-${siteName}-Site/default/ShippingController-SaveSthDeliveryDetails`,
};
